import { curry } from 'lodash-es';
/**
 * Curried, iteratee-first util functions
 */
export const matchString = curry((regexp, string) => string.match(regexp));
